<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="63.675" height="76" viewBox="0 0 63.675 76">
    <g transform="translate(-30 0)">
      <path class="a"
            d="M62.907,137.629c-6.921-6.009-24.911-19.535-26.825-26.6-1.849-6.859,6.291-29.337,8.726-38.233H81.151c2.435,8.9,10.431,31.374,8.582,38.233-1.913,7.065-19.906,20.591-26.826,26.6m31.461-25.361c2.4-8.883-7.366-34.006-10.146-44.279H41.586c-2.775,10.267-12.544,35.4-10.141,44.279,2.511,9.3,23.485,24.757,31.462,31.721,7.977-6.964,28.952-22.416,31.461-31.721"
            transform="translate(-1.068 -67.989)"/>
      <path class="a"
            d="M61.734,116.119c-3.769,0-8.28-.742-11.608-2.755-.484-.265-.573-.565-.263-1.32l1.489-3.5c.3-.7.574-.749,1.221-.486a25.627,25.627,0,0,0,8.675,2.058c3.68,0,4.776-1.485,4.776-3.065,0-1.754-1.133-2.76-4.864-4.164-6.171-2.359-10.248-4.682-10.248-9.544,0-4.957,3.284-8.9,10.425-8.9a24.075,24.075,0,0,1,9.813,2.012c.7.353.749.529.435,1.4l-1.139,3.283c-.3.831-.478.831-1.178.662a28.648,28.648,0,0,0-7.931-1.4c-2.541,0-3.505,1.093-3.505,2.41,0,1.534,1.232,2.409,5.126,3.987,5.96,2.323,10.2,4.468,10.2,10.161,0,6.133-4.6,9.153-11.429,9.153M46.144,75.032c-10.77,39.873-14.708,30.349,15.281,56.54,29.989-26.191,26.058-16.666,15.282-56.54Z"
            transform="translate(0.413 -66.525)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Serverhero"
}
</script>

<style scoped>
.icon .a {
  fill: #313131;
}
</style>